/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import {AbstractWizardState} from "./AbstractWizardState";
import RegistrationStatus
  , {IRegistrationStatusProps} from "../wizard/GatewayRegistration/RegistrationStatus";
import DIYGatewayManagement from "../DIYGatewayManagement";
import {RegistrationProcessState} from "./RegistrationProcessState";

/**
 * This models the summary stage of gateway registration.
 * This state transition happens once gateway registration yields a success or error result.
 */
export class RegistrationStatusState extends AbstractWizardState {

  /**
   * Constructor injection of page and registration success flag
   * @param {DIYGatewayManagement} page
   * @param {boolean} registrationSuccessful
   */
  constructor(page: DIYGatewayManagement, registrationSuccessful: boolean = false, message: string = "") {
    super(page);
    this.registrationSuccessful = registrationSuccessful;
    this.message = message;
  }

  /**
   * Get the content corresponding to the gateway registration status.
   * There is a possible transition if the registration fails.
   * In success case as it stands today, it marks the end of the application.
   * This may change when DIY becomes de-facto software deployment platform.
   *
   * @returns {JSX.Element}
   */
  //@Todo detemine if we need a HOME button.
  getContent(): JSX.Element {
    let state = this.page.state;
    let props: IRegistrationStatusProps = {
      epName: state.epName,
      isSuccess: this.registrationSuccessful,
      serialNumber: state.serialNumber,
      deviceId: state.deviceId,
      onRetry: this.retry,
      onContactSupport:  () => this.page.launchContactSupport(this),
      registeredSite:this.page.state.selectedSite
    };
    if (!!this.message) {
      props.message = this.message;
    }
    return <RegistrationStatus {...props}></RegistrationStatus>;
  }

  /**
   * Retry the gateway registration.
   */
  retry = () => {
    this.page.setState({
      registrationStatus: new RegistrationProcessState(this.page)
    });
  };
  /**
   * Check if the registration status corresponds to success status
   * @returns {boolean}
   */
  getIsSuccessState = () => {
    return this.registrationSuccessful;
  };

  private registrationSuccessful: boolean;

  private message: string;

}
